// ── AR Flow — NOVA INTERFACE: 📚 Catálogo (bastidor, só administração) ──────
// O que já está carregado no catálogo: fornecedores, data da tabela vigente,
// quantidade de produtos e o que falta conferir (pendências).
// Fonte: GET /api/produtos/catalogo-admin (o servidor só libera para a administração).

import { useEffect, useState } from "react";
import { EmPreparacao } from "./Produtos";

const MONO = "'IBM Plex Mono', ui-monospace, monospace";
const DISPLAY = "'Bricolage Grotesque', 'Source Sans 3', system-ui, sans-serif";
const num = v => (v == null ? "—" : Number(v).toLocaleString("pt-BR"));
const data = v => (v ? String(v).slice(0, 10).split("-").reverse().join("/") : "—");

export default function CatalogoAdmin({ theme }) {
  const th = theme;
  const line = th.nuLine || th.sandDark;
  const [estado, setEstado] = useState({ carregando: true });

  useEffect(() => {
    let vivo = true;
    fetch("/api/produtos/catalogo-admin", { credentials: "include" })
      .then(async r => {
        const d = await r.json().catch(() => ({}));
        if (r.status === 503 && d.conectado === false) return { conectado: false };
        if (!r.ok) throw new Error(d.erro || "Não foi possível carregar o catálogo.");
        return { conectado: true, ...d };
      })
      .then(d => vivo && setEstado({ carregando: false, ...d }))
      .catch(e => vivo && setEstado({ carregando: false, erro: e.message }));
    return () => { vivo = false; };
  }, []);

  const fornecedores = estado.fornecedores || [];
  const pendencias = estado.pendencias || [];
  const celula = { padding: "8px 6px", borderBottom: `1px solid ${line}`, fontSize: 13, color: th.text };

  return (
    <div>
      <div style={{ fontFamily: DISPLAY, fontSize: 26, fontWeight: 700, color: th.text }}>Catálogo</div>
      <div style={{ fontSize: 14, color: th.muted, marginBottom: 14 }}>O que já está carregado para a busca de produtos e o que falta conferir.</div>

      {estado.carregando && <div style={{ color: th.muted, fontSize: 14 }}>Carregando…</div>}
      {estado.erro && <div role="alert" style={{ color: "#991B1B", fontSize: 14 }}>{estado.erro}</div>}
      {estado.conectado === false && (
        <EmPreparacao th={th} titulo="Catálogo em preparação"
          texto="Quando o catálogo dos fornecedores estiver ligado ao CRM, aqui aparecem os fornecedores carregados, a data de cada tabela e as pendências para conferir (sofás a confirmar, fotos faltando, preços para consultar a fábrica)." />
      )}

      {estado.conectado && (
        <>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: 10, marginBottom: 14 }}>
            {[["Fornecedores", estado.totais?.fornecedores ?? fornecedores.length], ["Produtos", estado.totais?.produtos], ["Preços", estado.totais?.precos], ["Pendências", estado.totais?.pendencias ?? pendencias.length]].map(([n, v]) => (
              <div key={n} style={{ background: "#fff", border: `1px solid ${line}`, borderRadius: 4, padding: "12px 14px" }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: th.muted }}>{n}</div>
                <div style={{ fontFamily: MONO, fontSize: 22, color: th.text, marginTop: 4 }}>{num(v)}</div>
              </div>
            ))}
          </div>
          <div style={{ background: "#fff", border: `1px solid ${line}`, borderRadius: 4, padding: "12px 14px", overflowX: "auto" }}>
            <div style={{ fontWeight: 700, fontSize: 15, color: th.text, marginBottom: 6 }}>Fornecedores</div>
            <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 520 }}>
              <thead><tr>{["Fornecedor", "Produtos", "Tabela de", "Atualizado em", "Pendências"].map(c => <th key={c} style={{ ...celula, textAlign: "left", color: th.muted, fontWeight: 700 }}>{c}</th>)}</tr></thead>
              <tbody>{fornecedores.map(f => (
                <tr key={f.nome}><td style={{ ...celula, fontWeight: 700 }}>{f.nome}</td><td style={celula}>{num(f.produtos)}</td><td style={celula}>{data(f.tabelaData)}</td><td style={celula}>{data(f.atualizadoEm)}</td><td style={celula}>{num(f.pendencias)}</td></tr>
              ))}</tbody>
            </table>
          </div>
          {pendencias.length > 0 && (
            <div style={{ background: "#fff", border: `1px solid ${line}`, borderRadius: 4, padding: "12px 14px", marginTop: 12 }}>
              <div style={{ fontWeight: 700, fontSize: 15, color: th.text, marginBottom: 6 }}>Para conferir</div>
              {pendencias.slice(0, 100).map((p, i) => (
                <div key={p.id || i} style={{ padding: "7px 0", borderTop: `1px solid ${line}`, fontSize: 14, color: th.text }}>
                  <strong>{p.produto}</strong> <span style={{ color: th.muted }}>{p.fornecedor}</span>
                  <div style={{ fontSize: 13, color: th.muted }}>{p.descricao}</div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
